/**
 * This function takes a canvas, context, width and height. It scales both the
 * canvas and the context in such a way that everything you draw will be as
 * sharp as possible for the device.
 *
 * It doesn't return anything, it just modifies whatever canvas and context you
 * pass in.
 *
 * Adapted from Paul Lewis's code here:
 * http://www.html5rocks.com/en/tutorials/canvas/hidpi/
 * https://gist.github.com/callumlocke/cc258a193839691f60dd
 */

export default function scaleCanvas(
  canvas: HTMLCanvasElement,
  context: CanvasRenderingContext2D | any,
  width: number,
  height: number
) {
  const ratio = 2;

  // set the 'real' canvas size to the higher width/height
  canvas.width = width * ratio;
  canvas.height = height * ratio;

  // ...then scale it back down with CSS
  canvas.style.width = width + 'px';
  canvas.style.height = height + 'px';

  // scale the drawing context so everything will work at the higher ratio
  context.scale(ratio, ratio);
}
